// Paletas precargadas de "Fiesta de Colores" (cumpleaños infantil).
// "terciario" alimenta las ilustraciones y acentos lúdicos.
const FUENTES = {
  display: '"Baloo 2", system-ui, sans-serif',
  cuerpo: '"Nunito", system-ui, sans-serif',
};

export const paletas = [
  {
    clave: "confeti",
    nombre: "Confeti",
    tema: {
      colores: {
        fondo: "#FFF9F0",
        fondoAlt: "#FFF1DC",
        texto: "#33302E",
        textoSuave: "#6A6159",
        textoTenue: "#9A8F82",
        primario: "#E4572E",
        primarioSuave: "#FDE3D8",
        acento: "#F2B705",
        terciario: "#2E9E97",
        borde: "rgba(51, 48, 46, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "frutilla",
    nombre: "Frutilla",
    tema: {
      colores: {
        fondo: "#FFF6F7",
        fondoAlt: "#FDEAEA",
        texto: "#38222A",
        textoSuave: "#71555E",
        textoTenue: "#A78E96",
        primario: "#D63864",
        primarioSuave: "#FADBE4",
        acento: "#F2B705",
        terciario: "#5FA866",
        borde: "rgba(56, 34, 42, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
  {
    clave: "oceano",
    nombre: "Océano",
    tema: {
      colores: {
        fondo: "#F3FAFB",
        fondoAlt: "#E3F2F4",
        texto: "#173038",
        textoSuave: "#4A636B",
        textoTenue: "#86A0A8",
        primario: "#1E7A8C",
        primarioSuave: "#D7ECEF",
        acento: "#F2B705",
        terciario: "#E4572E",
        borde: "rgba(23, 48, 56, 0.14)",
      },
      fuentes: FUENTES,
    },
  },
];
